<template>
  <div class="stat-card" :class="{pointer:stat.cardAction}" @click="cardAction">
    <div class="stat-label">{{ stat.label }}</div>
    <div class="stat-value">{{ stat.value }}</div>
    <em class="small text-muted" v-if="stat.actionLabel">
      <button type="button" class="btn btn-link btn-sm p-0 text-muted" style="font-size:inherit;font-style:inherit;" @click="statAction">{{ stat.actionLabel }}</button>
    </em>
    <range-comparison v-if="stat.comparison" :curr-val="stat.comparison.current" :prev-val="stat.comparison.previous" :format="stat.comparison.format" :label="stat.comparison.label" :show-comparison-label="stat.comparison.showLabel" />
    <div class="stat-icon text-secondary"><i class="bi" :class="stat.icon || 'bi-receipt'"></i></div>
  </div>
</template>

<script setup>
import RangeComparison from "@/app/components/Utils/RangeComparison.vue";
import { defineProps, defineEmits } from "vue";

/**
 * stat {
 *   label
 *   value
 *   actionLabel
 *   comparison: {
 *     mode
 *     current
 *     previous
 *     label
 *     format
 *     showLabel
 *   }
 * }
 */
const props = defineProps(['stat'])
const emit = defineEmits(['action'])

function cardAction() {
  if (props.stat.cardAction) emit('action','stat')
}

function statAction() {
  // the condition prevents double emits
  if (!props.stat.cardAction) emit('action','stat')
}
</script>
